import React from "react";
import { globalData } from "../../global/js/globalData.js";
import TextareaAutoResize from "react-autosize-textarea";
import "./StayComponentCommentBox.scss";

const StayComponentCommentBox = ({ 
    componentComment, 
    componentID, 
    didNotRun, 
    displayName, 
    handleTextareaChange, 
    handleTextareaClear, 
    handleDidNotRun, 
    handleTextareaToggle
}) =>
    <div className='textarea-wrapper'>
        <a
            className='textarea__close'
            onClick={handleTextareaToggle}
        >
            {'\u00D7'}
        </a>

        <div>
            <h3 className='textarea__sub-heading'>
                {globalData.commentBoxIntroText} {displayName}
            </h3>

            <a
                className='textarea__clear'
                data-id={componentID}
                onClick={handleTextareaClear}
            >
                Clear
            </a>
        </div>

        <TextareaAutoResize
            autoFocus={true}
            className='textarea'
            data-id={componentID}
            onChange={(e) => handleTextareaChange(e)}
            rows={2}
            maxRows={8}
            value={componentComment}
        />

        <nav className='textarea__footer'>
            <label className='textarea__na'>
                <input
                    checked={didNotRun}
                    className='textarea__na__checkbox'
                    data-id={componentID}
                    name='didNotRun'
                    onChange={handleDidNotRun}
                    type='checkbox'
                />
                {globalData.commentBoxCheckBoxText}
            </label>

            <div className='textarea__footer__buttons'>
                <a
                    className='textarea__footer__buttons--complete'
                    onClick={handleTextareaToggle}
                >
                    Done
                </a>
            </div>
        </nav>
    </div>

export default StayComponentCommentBox;


// WEBPACK FOOTER //
// ./application/components/StayComponentCommentBox/StayComponentCommentBox.jsx